// import React from "react";
// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
//   ReferenceLine,
// } from "recharts";
// import { Card } from "@mui/material";

// const MetricChart = ({
//   data,
//   activeTab,
//   isMobile,
//   advisedSteps,
//   advisedCaloriesBurnt,
//   advisedActiveTime,
// }) => {
//   const getChartConfig = () => {
//     switch (activeTab) {
//       case "steps":
//         return {
//           dataKey: "steps",
//           color: "#05CFE6",
//           label: "Steps",
//           formatter: (value) => [value, "Steps"],
//         };
//       case "calories":
//         return {
//           dataKey: "calories",
//           color: "#05CFE6",
//           label: "Calories",
//           formatter: (value) => [`${value} kcal`, "Calories"],
//         };
//       case "activeMinutes":
//         return {
//           dataKey: "activeMinutes",
//           color: "#05CFE6",
//           label: "Active Minutes",
//           formatter: (value) => [`${value} min`, "Active Time"],
//         };
//       default:
//         return {
//           dataKey: "steps",
//           color: "#05CFE6",
//           label: "Steps",
//           formatter: (value) => [value, "Steps"],
//         };
//     }
//   };

//   const getAdvisedValue = () => {
//     switch (activeTab) {
//       case "steps":
//         return advisedSteps;
//       case "calories":
//         return advisedCaloriesBurnt;
//       case "activeMinutes":
//         return advisedActiveTime;
//       default:
//         return null;
//     }
//   };

//   const advisedValue = getAdvisedValue();
//   const config = getChartConfig();
//   const currentData = data[activeTab] || [];

//   return (
//     <div className="relative px-2">
//       <div className="overflow-x-auto">
//         {/* minWidth ensures the chart content forces the scrollbar */}
//         <div style={{ minWidth: currentData?.length > 4 ? "600px" : "100%" }}>
//           <ResponsiveContainer
//             width="100%"
//             height={300}
//             //  minWidth={currentData?.length > 4 ? 1000 : undefined}
//           >
//             <LineChart
//               data={currentData}
//               margin={
//                 isMobile
//                   ? { top: 5, right: 10, left: -30, bottom: 25 }
//                   : { top: 5, right: 20, left: -10, bottom: 5 }
//               }
//             >
//               <CartesianGrid
//                 strokeDasharray="3 3"
//                 vertical={false}
//                 stroke="#D6D6D6"
//               />
//               <XAxis
//                 dataKey="name"
//                 axisLine={false}
//                 tickLine={false}
//                 tick={{
//                   fill: "#6B7280",
//                   fontSize: isMobile ? 10 : 12,
//                 }}
//                 interval={0}
//                 padding={{
//                   left: isMobile ? 30 : 10,
//                   right: isMobile ? 30 : 10,
//                 }}
//               />
//               <YAxis
//                 axisLine={false}
//                 tickLine={false}
//                 domain={[0, "auto"]}
//                 tick={{
//                   fill: "#6B7280",
//                   fontSize: isMobile ? 10 : 12,
//                 }}
//               />
//               <Tooltip
//                 formatter={config.formatter}
//                 labelFormatter={(label) => {
//                   const dataPoint = currentData.find((d) => d.name === label);
//                   return dataPoint?.fullDate || label;
//                 }}
//               />
//               <Line
//                 type="monotone"
//                 dataKey={config.dataKey}
//                 stroke={config.color}
//                 strokeWidth={3}
//                 dot={{ r: isMobile ? 3 : 5, fill: config.color }}
//                 activeDot={{ r: isMobile ? 5 : 8, fill: config.color }}
//               />
//               {advisedValue > 0 && (
//                 <ReferenceLine
//                   y={advisedValue}
//                   stroke="#FF8B38"
//                   strokeDasharray="6 6"
//                   strokeWidth={2}
//                   ifOverflow="extendDomain"
//                 />
//               )}
//             </LineChart>
//           </ResponsiveContainer>
//         </div>
//       </div>

//       {/* Metric indicator */}
//       {/* <div className={`absolute ${isMobile ? "top-4" : "top-8"} left-1/2 transform -translate-x-1/2`}>
//         <Card className="text-center py-3 px-4 border border-[#E0E0E0] !shadow-sm">
//           <div className="text-xs text-[#636363] mb-1">
//             Total {config.label}
//           </div>
//           <div className="flex items-center justify-center gap-2">
//             <div
//               className="w-3 h-3 rounded-[3px]"
//               style={{ backgroundColor: config.color }}
//             ></div>
//             <p className="text-[16px] text-[#636363]">
//               {getTotalValue ? getTotalValue(activeTab) : '0'}
//             </p>
//           </div>
//         </Card>
//       </div> */}
//     </div>
//   );
// };

// export default MetricChart;

import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine,
} from "recharts";

const MetricChart = ({
  data,
  activeTab,
  isMobile,
  advisedSteps,
  advisedCaloriesBurnt,
  advisedActiveTime,
}) => {
  const getChartConfig = () => {
    switch (activeTab) {
      case "steps":
        return {
          dataKey: "steps",
          color: "#05CFE6",
          label: "Steps",
          formatter: (value) => [value, "Steps"],
        };
      case "calories":
        return {
          dataKey: "calories",
          color: "#05CFE6",
          label: "Calories",
          formatter: (value) => [`${value} kcal`, "Calories"],
        };
      case "activeMinutes":
        return {
          dataKey: "activeMinutes",
          color: "#05CFE6",
          label: "Active Minutes",
          formatter: (value) => [`${value} min`, "Active Time"],
        };
      default:
        return {
          dataKey: "steps",
          color: "#05CFE6",
          label: "Steps",
          formatter: (value) => [value, "Steps"],
        };
    }
  };

  const getAdvisedValue = () => {
    switch (activeTab) {
      case "steps":
        return Number(advisedSteps) || 0;
      case "calories":
        return Number(advisedCaloriesBurnt) || 0;
      case "activeMinutes":
        return Number(advisedActiveTime) || 0;
      default:
        return 0;
    }
  };

  const advisedValue = getAdvisedValue();
  const config = getChartConfig();
  const currentData = data[activeTab] || [];

  // Calculate Y-Axis domain to include advisedValue
  // Calculate Y-Axis domain to include advisedValue and snap to clean intervals
  const getYDomain = () => {
    if (advisedValue <= 0 && currentData.length === 0) return [0, "auto"];

    return [
      0,
      (dataMax) => {
        const highestPoint = Math.max(dataMax, advisedValue);

        // If the value is very small, use a smaller step
        if (highestPoint < 100) return Math.ceil(highestPoint / 10) * 10 + 10;

        // Snap to the next 100 or 500 for a cleaner look
        // For values > 1000, snap to next 200
        const step = highestPoint > 1000 ? 200 : 100;
        return Math.ceil((highestPoint + highestPoint * 0.05) / step) * step;
      },
    ];
  };

  return (
    <div className="relative px-2">
      <div className="overflow-x-auto">
        <div style={{ minWidth: currentData?.length > 4 ? "600px" : "100%" }}>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart
              data={currentData}
              margin={
                isMobile
                  ? { top: 20, right: 10, left: -30, bottom: 25 }
                  : { top: 20, right: 20, left: -10, bottom: 5 }
              }
            >
              <CartesianGrid
                strokeDasharray="3 3"
                vertical={false}
                stroke="#D6D6D6"
              />
              <XAxis
                dataKey="name"
                axisLine={false}
                tickLine={false}
                tick={{
                  fill: "#6B7280",
                  fontSize: isMobile ? 10 : 12,
                }}
                interval={0}
                padding={{
                  left: isMobile ? 30 : 10,
                  right: isMobile ? 30 : 10,
                }}
              />
              <YAxis
                axisLine={false}
                tickLine={false}
                // FIXED: This forces the Y-Axis to include the advised line
                domain={getYDomain()}
                tick={{
                  fill: "#6B7280",
                  fontSize: isMobile ? 10 : 12,
                }}
              />
              <Tooltip
                formatter={config.formatter}
                labelFormatter={(label) => {
                  const dataPoint = currentData.find((d) => d.name === label);
                  return dataPoint?.fullDate || label;
                }}
              />

              {advisedValue > 0 && (
                <ReferenceLine
                  y={advisedValue}
                  stroke="#FF8B38"
                  strokeDasharray="6 6"
                  strokeWidth={2}
                  ifOverflow="extendDomain"
                  label={{
                    value: `${config.label} Goal: ${advisedValue}`,
                    position: "top", 
                    offset: 10,
                    fill: "#FF8B38",
                    fontSize: isMobile ? 10 : 12,
                    fontWeight: "bold",
                    background: { fill: "white", fillOpacity: 0.8 },
                  }}
                />
              )}

              <Line
                type="monotone"
                dataKey={config.dataKey}
                stroke={config.color}
                strokeWidth={3}
                dot={{ r: isMobile ? 3 : 5, fill: config.color }}
                activeDot={{ r: isMobile ? 5 : 8, fill: config.color }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default MetricChart;
